package songwritersnotebook.app.data

import kotlinx.serialization.Serializable

@Serializable
data class SendInvitationRequest(
    val songId: String,
    val email: String,
    val role: String
)

@Serializable
data class RespondToInvitationRequest(
    val invitationId: String,
    val accept: Boolean
)

@Serializable
data class SaveSongRequest(
    val songId: String,
    val lastModified: Long, // Epoch millis
    val revisionId: String? = null,
    val crdtState: String? = null, // Automerge binary state (base64)
    val song: Song? = null, // Full song object for full saves/creation
    val section: Section? = null, // Granular section update
    val line: Line? = null, // Granular line update
    val track: Track? = null, // Granular track update
    val trackItem: TrackItem? = null, // Granular track item update
    val sections: List<Section>? = null, // Bulk section update
    val tracks: List<Track>? = null, // Bulk track update
    val deletedLineIds: List<String>? = null, // Bulk line deletion
    val deletedSectionIds: List<String>? = null, // Bulk section deletion
    val deletedTrackIds: List<String>? = null, // Bulk track deletion
    val deletedTrackItemIds: List<String>? = null, // Bulk track item deletion
    val chordDefinitions: Map<String, ChordDefinition>? = null, // Chord library update
    val title: String? = null,
    val bpm: Int? = null,
    val guitarTuning: List<String>? = null,
    val guitarCapo: Int? = null,
    val showPianoInfo: Boolean? = null,
    val showGuitarInfo: Boolean? = null,
    val isPublic: Boolean? = null,
    val isDeleted: Boolean? = null,
    val notes: String? = null,
    val showNotes: Boolean? = null
)

@Serializable
data class SaveSongResponse(
    val status: String,
    val message: String,
    val revisionId: String? = null,
    val lastModified: Long? = null,
    val isNewSong: Boolean? = null,
    val finalSongData: kotlinx.serialization.json.JsonElement? = null,
    val totalBytes: Long? = null
)

@Serializable
data class FindUserRequest(
    val email: String
)

@Serializable
data class FindUserResponse(
    val uid: String,
    val email: String
)

@Serializable
data class RegisterSessionRequest(
    val deviceId: String,
    val deviceName: String,
    val platform: String
)

@Serializable
data class RemoveSessionRequest(
    val deviceId: String
)

@Serializable
data class UpdateUsernameRequest(
    val username: String
)

@Serializable
data class UpdateUsernameResponse(
    val status: String,
    val username: String
)

@Serializable
data class SearchUsersResponse(
    val users: List<PublicUser>
)
